<!--
 * @Author: DQL
 * @Date: 2020-03-16 21:56:03
 * @LastEditors: DQL
 * @LastEditTime: 2021-05-06 10:31:30
 * @Description: file content
 -->

<template>
  <div
    class="l-page--inner l-page--detail"
  >
    <!-- 页面头部 Start -->
    <div
      class="l-page__header c-page__header"
    >
      <!-- 页面标题 -->
      <h2
        class="c-page__header-title"
      >
        菜单信息
      </h2>

      <!-- 标题栏按钮区域 Start -->
      <div
        class="c-page__header-btns"
      >
        <el-button
          type="primary"
          icon="kestrel-icon ki-plus"
          :disabled="menu.menuType===disableAddMenuType"
          @click="handleAdd()"
        >
          新增下级菜单
        </el-button>
        <el-button
          type="success"
          icon="kestrel-icon ki-edit"
          @click="handleClickSwitchToEdit()"
        >
          编辑
        </el-button>
        <el-button
          icon="kestrel-icon ki-trash-o"
          type="danger"
          @click="handleDel()"
        >
          删除
        </el-button>
      </div>
      <!-- 标题栏按钮区域 End -->
    </div>
    <!-- 页面头部 End -->

    <!-- 页面主内容：详情 Start -->
    <div
      class="l-page__body l-page--detail__body"
    >
      <hm-page-card
        class="c-card--detail"
      >
        <el-form
          class="c-form"
          :inline="true"
          label-position="right"
          label-width="140px"
          label-suffix="："
        >
          <el-row
            class="c-form__row"
          >
            <el-col
              v-if="menu.parentMenuName"
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="上级菜单"
              >
                <span
                  class="c-form__read"
                >
                  {{ menu.parentMenuName }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="安全控制类别"
              >
                <span
                  class="c-form__read"
                >
                  {{ menu.securityName }}
                </span>
              </el-form-item>
            </el-col>
            <!-- <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="所属业务系统"
                prop="appCode"
              >
                <span
                  class="c-form__read"
                >
                {{ menu.appName }}
                </span>
              </el-form-item>
            </el-col> -->
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="菜单名称"
                prop="menuName"
              >
                <span
                  class="c-form__read"
                >
                  {{ menu.menuName }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="菜单类型"
                prop="menuType"
              >
                <span
                  class="c-form__read"
                >
                  {{ menu.menuType | enums('BASE_MENU_TYPE') }}
                </span>
              </el-form-item>
            </el-col>
            <template v-if="menu.menuType==='1'">
              <el-col
                class="c-form__col"
                :span="24"
              >
                <el-form-item
                  class="c-form__item"
                  label="打开方式"
                  prop="openType"
                >
                  <span
                    class="c-form__read"
                  >
                    {{ menu.openType | enums('BASE_MENU_OPEN_TYPE') }}
                  </span>
                </el-form-item>
              </el-col>
              <el-col
                class="c-form__col"
                :span="24"
              >
                <el-form-item
                  class="c-form__item"
                  label="菜单链接"
                  prop="menuUrl"
                >
                  <span
                    class="c-form__read"
                  >
                    {{ menu.menuUrl }}
                  </span>
                </el-form-item>
              </el-col>
            </template>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="图标样式"
                prop="icon"
              >
                <span
                  class="c-form__read"
                >
                  {{ menu.icon }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="图标预览"
                prop="icon"
              >
                <span
                  class="c-form__read"
                ><i
                  :class="['u-text-lg', previewMenuIcon(menu.icon)]"
                /></span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </hm-page-card>
    </div>
    <!-- 页面主内容：详情 End -->
  </div>
</template>

<script>
import { delMenu } from './menu.service';

export default {
  name: 'ViewMenu',
  props: {
    menu: {
      type: Object,
      default () {
        return {
          menuName: null,
          menuType: null,
          icon: null,
          openType: null,
          menuUrl: null,
          parentMenuCode: null
        };
      }
    }
  },
  data () {
    return {};
  },
  computed: {
    // 禁止添加下级菜单的菜单类型
    disableAddMenuType () {
      const enums = this.$HMStoreService.getEnums();
      if (enums && enums.BASE_MENU_TYPE) {
        return enums.BASE_MENU_TYPE.ENUM_KEY_1.id;
      }
      return '';
    }
  },
  methods: {
    /**
     * @description: 触发切换页面状态为新增
     * @param {*}
     * @return {*}
     */
    handleAdd () {
      this.$emit('switch', 'addMenu');
    },
    /**
     * @description: 触发切换页面状态为编辑菜单
     * @param {*}
     * @return {*}
     */
    handleClickSwitchToEdit () {
      this.$emit('switch', 'editMenu');
    },
    /**
     * @description: 删除
     * @param {*}
     * @return {*}
     */
    handleDel () {
      const _this = this;
      _this.$confirm(`是否删除菜单【${_this.menu.menuName}】？`, '提示', {
        type: 'warning'
      }).then(() => {
        delMenu(_this.menu.menuCode)
          .then(rsp => {
            _this.$alert('删除成功！', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {
              }
            });
            _this.$emit('reload');
          });
      });
    },
    /**
     * @description: 菜单图标样式重组
     * @param {String} _icon, 图标样式
     * @return {*}
     */
    previewMenuIcon (_icon) {
      if (!_icon) {
        return;
      }
      // 例如传入 fa-cog
      if (_icon.indexOf('fa ') < 0 && _icon.indexOf('fa-') > -1) {
        return 'fa ' + _icon;
      }
      // 例如传入 ki-cog
      if (_icon.indexOf('ki ') < 0 && _icon.indexOf('ki-') > -1) {
        return 'kestrel-icon ' + _icon;
      }
      // 例如传入 icon-cog
      if (_icon.indexOf('iconfont ') < 0 && _icon.indexOf('icon-') > -1) {
        return 'iconfont ' + _icon;
      }
      return _icon;
    }
  }
};
</script>
